import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiDeleteBookmarkVariables = Types.Exact<{
  bookmarkId: Types.Scalars['String'];
}>;


export type ApiDeleteBookmark = { deleteBookmark: boolean };



export const ApiDeleteBookmarkDocument = /*#__PURE__*/ `
    mutation DeleteBookmark($bookmarkId: String!) {
  deleteBookmark(bookmarkId: $bookmarkId)
}
    `;

export const useDeleteBookmark = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiDeleteBookmark, TError, ApiDeleteBookmarkVariables, TContext>) => {
    
    return useMutation<ApiDeleteBookmark, TError, ApiDeleteBookmarkVariables, TContext>(
      {
    mutationKey: ['DeleteBookmark'],
    mutationFn: (variables?: ApiDeleteBookmarkVariables) => apiFetcher<ApiDeleteBookmark, ApiDeleteBookmarkVariables>(ApiDeleteBookmarkDocument, variables)(),
    ...options
  }
    )};


useDeleteBookmark.fetcher = (variables: ApiDeleteBookmarkVariables, options?: RequestInit['headers']) => apiFetcher<ApiDeleteBookmark, ApiDeleteBookmarkVariables>(ApiDeleteBookmarkDocument, variables, options);
